var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-layout"},[_c('div',{staticClass:"app-pages"},[_vm._t("default")],2),_c('div',{staticClass:"notifications-container"},[_c('MailNotification'),_c('Cookies')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }